import useId from './useId';
export default function useComponentId() {
    const id = useId();
    return `r__${id}`;
}
